import { createRoute } from "@tanstack/react-router";

import { activeMemberQueryOptions } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { AiAppsPage } from "./ai-apps.page";

// Every role reads how to connect. The list of connected apps checks its own permission. The
// membership loads before the page, so the page never mistakes a pending role for none.
export const aiAppsRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/ai-apps",
	beforeLoad: async ({ context }) => {
		await context.queryClient.ensureQueryData(activeMemberQueryOptions);
	},
	component: AiAppsPage,
});
